import { IXepLoaiHocTapActionTypes } from "../../action-types/category/IXepLoaiHocTapActions";
import { IXepLoaiHocTapReducer } from "../../reducer-model/category/IXepLoaiHocTapReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IXepLoaiHocTapReducer = {
    status: eReducerStatusBase.is_not_initialization,
    xepLoaiHocTaps: [],
}

export const xepLoaiHocTapReducer = (state = iniState, action: IXepLoaiHocTapActionTypes): IXepLoaiHocTapReducer => {
    switch (action.type) {
        case "XEP_LOAI_HOC_TAP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XEP_LOAI_HOC_TAP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                xepLoaiHocTaps: action.payload,
            };
        case "XEP_LOAI_HOC_TAP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XEP_LOAI_HOC_TAP_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                xepLoaiHocTapEditing: action.payload,
            };
        case "XEP_LOAI_HOC_TAP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "XEP_LOAI_HOC_TAP_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "XEP_LOAI_HOC_TAP_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "XEP_LOAI_HOC_TAP_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XEP_LOAI_HOC_TAP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "XEP_LOAI_HOC_TAP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XEP_LOAI_HOC_TAP_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}